import type { ReactNode } from 'react'
import { LocalizedLink } from '#src/components/LocalizedLink.js'

interface Props {
  title?: string
}

export function NotFoundView(props: Props): ReactNode {
  return (
    <main style={{ padding: '120px 24px', textAlign: 'center' }}>
      <h1 style={{ marginBottom: 16 }}>{props.title || 'Page not found'}</h1>
      <LocalizedLink href="/">Back to home</LocalizedLink>
    </main>
  )
}
